import React, { useContext } from "react";
import { Stack, ListTable, Shimmer, MultiselectSearchDropdown, PivotItem, Pivot } from "sprint-common-web";

import { AppConfigContext } from "../../../../../../../../core/configuration/Configuration";
import { environmentResolver } from "../../../../../../../../core/types/Environment";
import { createRekognitionResultListingColumns } from "./createRekognitionResultListingColumns";
import { useRekognitionResultListing } from "./useRekognitionResultListing";
import { useRekognitionResultListingFilters } from "./useRekognitionResultListingFilters";

export const RekognitionResultListing = (): JSX.Element => {
    const { filters, setTypes, setSort } = useRekognitionResultListingFilters();
    const { items, isLoading, selectedItems, setSelectedItems, typeOptions } = useRekognitionResultListing(filters);

    const { environment } = useContext(AppConfigContext);

    const resolvedEnvironment = environmentResolver(environment);

    const rekognitionResultsColumns = createRekognitionResultListingColumns(resolvedEnvironment);

    return !isLoading ? (
        <Stack styles={{ root: { ...defaultRootStyles } }}>
            <Pivot selectedKey={"RekognitionResults"} key={"RekognitionResults"}>
                <PivotItem
                    headerText="Rekognition results"
                    itemKey={"RekognitionResults"}
                    headerButtonProps={{
                        "data-testid": "rekognition-results-tab-button"
                    }}
                >
                    <Stack styles={{ root: { marginTop: 5 } }}>
                        <br />
                        <MultiselectSearchDropdown
                            placeholder={"Type"}
                            selectedKeys={filters.typeIds}
                            onChange={setTypes}
                            options={typeOptions}
                        />
                        <br />
                        <Stack styles={{ root: { marginTop: 30, overflow: "auto", maxHeight: 400 } }}>
                            <ListTable
                                columns={rekognitionResultsColumns}
                                items={items}
                                isLoading={isLoading}
                                selectedItems={selectedItems}
                                onSelectionChange={setSelectedItems}
                                maintainSelection={true}
                                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                                onSortChange={setSort}
                            />
                        </Stack>
                    </Stack>
                </PivotItem>
            </Pivot>
        </Stack>
    ) : (
        <Shimmer />
    );
};

const defaultRootStyles = {
    height: "100%",
    paddingLeft: 40,
    marginLeft: 40,
    borderLeft: "1px solid rgb(243, 242, 241)",
    "--stack-height": "100%"
};
